<template>
</template>

<script>
import firebase from 'firebase/app'

export default {
  async created() {
    let ret = null
    ret = await this.$store.dispatch('unsuscribeOrder')
    ret = await this.$store.dispatch('unsuscribeReminder')
    ret = await this.$store.dispatch('unsuscribeUser')
    
    firebase
        .auth()
        .signOut()
        .then( () => this.$router.replace({name: 'Login'})
        .catch(err => {}))
  }
};
</script>